import { Col, Row, Typography } from "antd";
import React from "react";
import { Modal } from "../../common/modal";
import { truncateHtmlToPlainText } from "@/utils/index";
import defaultProductImage from "./images/default-product.jpeg";

export type TemplateGalleryModalProps = {
  open: boolean;
  onClose?: () => void;
  onOk?: () => void;
  modalTitle?: string;
  loading?: boolean;
  okText?: string;
  image?: string | null;
  description?: string | null;
  price?: string | number | null;
  title?: string | null;
};

export const TemplateGalleryModal: React.FC<TemplateGalleryModalProps> = ({
  open,
  onClose,
  onOk,
  modalTitle = "Add Product",
  loading = false,
  okText = "Add New",
  image,
  description,
  price,
  title,
}) => {
  return (
    <Modal
      open={open}
      title={modalTitle}
      onCancel={onClose}
      onOk={onOk}
      confirmLoading={loading}
      okType='danger'
      okText={okText}
    >
      <Row gutter={[18, 0]}>
        <Col>
          <img
            src={image ? image : defaultProductImage}
            alt={title as string}
            width={130}
            height={130}
          />
        </Col>
        <Col>
          <Row>
            <Col span={24}>
              <Typography.Text
                style={{
                  fontWeight: "bold",
                  fontSize: "25px",
                  lineHeight: "30px",
                  color: "#f39c12",
                }}
              >
                {price}
              </Typography.Text>
            </Col>
            <Col span={24}>
              <Typography.Text style={{ fontWeight: "bold", fontSize: "25px", lineHeight: "30px" }}>
                {title}
              </Typography.Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Typography.Paragraph style={{ lineHeight: "24px", fontSize: "16px" }}>
            {description && truncateHtmlToPlainText(description, 160)}
          </Typography.Paragraph>
        </Col>
      </Row>
    </Modal>
  );
};
